import {
  PLStageActivityDto,
  PLStakeholderMatrixDto,
  HierarchyDto,
  PLStakeholderMatrixRaciDto,
  StakeholderDto,
  PipelineLicenseStakeholderDto,
  PipelineLicenseStageDto,
  PLActivityActionPersonDto,
  PlrstageactivityDto,
  PipelineLicenseCategoryDto,
  IdentityUserDto,
  PipelineTemplateDto,
} from '@cradua/data';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AddPlStageActivityComponent } from '../add-pl-stage-activity/add-pl-stage-activity.component';
import Swal from 'sweetalert2';
import { FormArray, FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'cradua-pl-stage-activity',
  templateUrl: './pl-stage-activity.component.html',
  styleUrls: ['./pl-stage-activity.component.css'],
})
export class PlStageActivityComponent implements OnInit {
  @Output() addplstageevent = new EventEmitter<any[]>();
  @Output() deleteventActivity = new EventEmitter<any>();
  @Output() deleteventMatrix = new EventEmitter<any>();
  @Output() deleteventRaci = new EventEmitter<any>();
  @Output() deleteventStage = new EventEmitter<any>();
  @Output() deletePlrsEvent = new EventEmitter<any>();
  @Output() submittempevent = new EventEmitter<any>();
  @Output() viewTemplateEvent = new EventEmitter<any>();
  @Input() plstageactivities: PLStageActivityDto[];
  @Input() plstakeholdersmatrix: PLStakeholderMatrixDto[];
  @Input() plstakeholdersmatrixraci: PLStakeholderMatrixRaciDto[];
  @Input() racies: HierarchyDto[];
  @Input() stakeholders: PipelineLicenseStakeholderDto[];
  @Input() stages: PipelineLicenseStageDto[];
  @Input() actionpersons: PLActivityActionPersonDto[];
  filteredstagies: PipelineLicenseStageDto[] = [];
  @Input() stagecategories: PipelineLicenseCategoryDto[];
  @Input() identityusers: IdentityUserDto[];
  @Input() plrstageactivies: PlrstageactivityDto[] = [];
  templateId;
  filteredMatrix: PLStakeholderMatrixDto[];
  filteredDelete: [];
  stage: PipelineLicenseStageDto;
  activity: PLStageActivityDto;
  newStage = false;
  selectedCategory = new BehaviorSubject('');
  viewlist;
  selectedId;
  selectedMatrix;
  viewracilist;
  newActivity: boolean;
  selectedCategoryId;
  selectedMatrixId: any;
  activityId;
  newMatrix = false;
  filteredmatrixs: PLStakeholderMatrixDto[];
  @Input() selectedData: any;
  @Input() templates: PipelineTemplateDto[];

  @ViewChild(AddPlStageActivityComponent)
  addstageActivitComponent: AddPlStageActivityComponent;
  data: any;

  constructor(private fb: FormBuilder, private matSnackBar: MatSnackBar) {}

  ngOnInit(): void {
    // this.selectCategory(this.selectedCategoryId)
  }

  ngOnChanges() {
    this.templateId = this.selectedData.id;
    this.selectedCategoryId = this.selectedData.selectedCategoryId;
    this.selectCategory(this.selectedCategoryId);
  }
  filterPixStakeholderMatrix(id) {
    const filtereds = this.plstakeholdersmatrix.filter(
      (data) => data.PLStageActivityId === id
    );
    return filtereds;
  }

  filterPixStakeholderMatrixRaci(id) {
    const filtereds = this.plstakeholdersmatrixraci.filter(
      (data) => data.PLStakeholderMatrixId === id
    );
    return filtereds;
  }

  selectCategory(id) {
    this.newStage = false;
    (this.selectedCategoryId = id), (this.stage = null);
    this.selectedCategory.next(id);
    console.log('id', id);
    this.filteredstagies = this.stages
      .filter(
        (stage) =>
          stage.PipelineLicenseCategoryId === id &&
          stage.TemplateId === this.templateId
      )
      .sort((a, b) => a.StageNo - b.StageNo);
  }

  getStakeholderName(item) {
    return this.stakeholders.find((a) => a.id === item.PLStakeholderId);
    // return holder ? holder.PipelineLicenseStakeholderName: '';
  }

  getCategory() {
    let cat = this.stagecategories.find(
      (cat) => cat.id === this.selectedCategoryId
    );
    return cat ? cat.PipelineLicenseCategoryName : '';
  }
  getTemplate() {
    return this.templates.find((temp) => temp.id === this.templateId);
  }
  getRaci(item) {
    const stakeholderraci = this.plstakeholdersmatrixraci.find(
      (a) => a.PLStakeholderMatrixId === item.id
    );

    if (stakeholderraci) {
      const raci = this.racies.find((a) => a.id === stakeholderraci.RaciId);
      return raci ? raci : null;
    } else {
      return null;
    }
  }

  getActivityName(id) {
    const activity = this.plstageactivities.find((a) => a.id === id);
    return activity ? activity.Name : '';
  }

  viewList(id) {
    this.selectedId = id;
    this.viewlist = true;
  }

  filterActivity(id) {
    return this.plstageactivities
      .filter((act) => act.PLStageId === id)
      .sort((a, b) => a.ActivityNo - b.ActivityNo);
  }

  selectStage(id) {
    this.activity = null;
    this.newStage = false;
    this.stage = this.stages.find((stage) => stage.id === id);
  }

  backToTemplate() {
    this.viewTemplateEvent.emit({ isview: false });
  }

  selectActivity(id) {
    this.activity = this.plstageactivities.find(
      (activity) => activity.id === id
    );
  }

  createStage() {
    this.stage = null;
    this.newStage = true;
  }

  // viewRaciList(id) {
  //   this.selectedMatrixId= id;
  //   this.viewracilist = true;
  // }

  editActivity(activity) {
    this.newStage = true;
    const stage = this.stages.find((st) => st.id === activity.PLStageId);
    const plstakeholdersmatrix = this.plstakeholdersmatrix.filter(
      (aaa) => aaa.PLStageActivityId === activity.id
    );
    const actionpsersons = this.actionpersons.filter(
      (ss) => ss.PLStageActivityId === activity.id
    );
    const Stakeholdermatrix = [];
    const Actionpersons = [];

    if (plstakeholdersmatrix.length > 0) {
      plstakeholdersmatrix.map((mm) => {
        const matrixdata = {
          id: mm.id,
          isNew: false,
          CreatedById: mm.CreatedById,
          ModifiedById: mm.ModifiedById,
          SiteId: mm.SiteId,
          TemplateId: mm.TemplateId,
          SubscriberId: mm.SubscriberId,
          EstimatedDuration: mm.EstimatedDuration,
          PLStakeholderId: mm.PLStakeholderId,
          PLStageActivityId: mm.PLStageActivityId,
          Racies: this.plstakeholdersmatrixraci.filter(
            (rr) => rr.PLStakeholderMatrixId === mm.id
          ),
        };
        Stakeholdermatrix.push(matrixdata);
      });
    }

    if (actionpsersons.length > 0) {
      actionpsersons.map((ss) => {
        const matrixdata = {
          id: ss.id,
          isNew: false,
          CreatedById: ss.CreatedById,
          ModifiedById: ss.ModifiedById,
          SiteId: ss.SiteId,
          SubscriberId: ss.SubscriberId,
          StaffId: ss.StaffId,
          PLStageActivityId: ss.PLStageActivityId,
        };
        Actionpersons.push(matrixdata);
      });
    }

    if (stage) {
      const stagData = {
        PipelineLicenseStageName: stage.PipelineLicenseStageName,
        PipelineLicenseCategoryId: stage.PipelineLicenseCategoryId,
        EstimatedDuration: stage.EstimatedDuration,
        StageNo: stage.StageNo,
        TemplateId: stage.TemplateId,
        newStage: false,
        id: stage.id,
        Activity: {
          id: activity.id,
          isNew: false,
          CreatedById: activity.CreatedById,
          ModifiedById: activity.ModifiedById,
          SiteId: activity.SiteId,
          SubscriberId: activity.SubscriberId,
          PLStageId: activity.PLStageId,
          Name: activity.Name,
          TemplateId: activity.TemplateId,
          ActivityNo: activity.ActivityNo,
          EstimatedDuration: activity.EstimatedDuration,
          Actionpersons: Actionpersons,
          Stakeholdermatrix: Stakeholdermatrix,
        },
      };
      setTimeout(() => {
        this.addstageActivitComponent.editSavedData(stagData);
      }, 100);
    } else {
    }
  }

  createTask(stage) {
    this.newStage = true;
    const stagData = {
      PipelineLicenseStageName: stage.PipelineLicenseStageName,
      PipelineLicenseCategoryId: stage.PipelineLicenseCategoryId,
      TemplateId: stage.TemplateId,
      EstimatedDuration: stage.EstimatedDuration,
      StageNo: stage.StageNo,
      newStage: false,
      id: stage.id,
    };

    setTimeout(() => {
      this.addstageActivitComponent.createTask(stagData);
    }, 100);
  }

  onDeleteMatrixEvent(data) {
    this.deleteventMatrix.emit(data);
  }

  onDeleteRaciEvent(data) {
    this.deleteventRaci.emit(data);
  }

  onDeleteActivityEvent(data) {
    this.deleteventActivity.emit(data);
  }

  onDeleteStage(data) {
    this.deleteventStage.emit(data);
  }

  onSubmitActivity(data) {
    this.addplstageevent.emit(data);
    this.newStage = false;
  }

  selectTask(task: PLStageActivityDto) {
    if (this.newStage) {
      this.editActivity(task);
    }
    this.stage = this.stages.find((stage) => stage.id === task.PLStageId);
    if (this.stage) {
      this.activity = this.plstageactivities.find(
        (activity) => activity.id === task.id
      );
    }
  }

  DeleteActivity(id: string, plsStateId: string) {
    if (this.checkPLRStage(plsStateId)) {
      this.deleteErrMsg();
      return;
    }
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        this.plstageactivities = this.plstageactivities.filter(
          (pp) => pp.id !== id
        );
        this.deleteventActivity.emit(id);
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  deleteStage(id: string, plsStateId: string) {
    if (this.checkPLRStage(plsStateId)) {
      console.log(this.checkPLRStage(plsStateId));

      this.deleteErrMsg();
      return;
    }
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        this.plstageactivities = this.plstageactivities.filter(
          (pp) => pp.id !== id
        );
        this.deleteventStage.emit(id);
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  DeleteMatrix(id: string, plsStateId: string) {
    if (this.checkPLRStage(plsStateId)) {
      this.deleteErrMsg();
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        this.plstakeholdersmatrix = this.plstakeholdersmatrix.filter(
          (mx) => mx.PLStakeholderId !== id
        );
        this.deleteventMatrix.emit(id);
        this.deletePlrsEvent.emit(id);
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  DeleteMatrixRaci(id: string, plsStateId: string) {
    if (this.checkPLRStage(plsStateId)) {
      this.deleteErrMsg();
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        this.plstakeholdersmatrixraci = this.plstakeholdersmatrixraci.filter(
          (mx) => mx.PLStakeholderMatrixId !== id
        );

        this.deleteventRaci.emit(id);
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  checkActivity(id: string) {
    const check = this.plstakeholdersmatrix.find(
      (a) => a.PLStageActivityId === id
    );
    return check ? true : false;
  }

  checkStage(id) {
    const check = this.plstageactivities.find((a) => a.PLStageId === id);
    return check ? true : false;
  }

  checkMatrix(id: string) {
    return this.plstakeholdersmatrixraci.find(
      (a) => a.PLStakeholderMatrixId === id
    );
  }

  getPLStageName(id: string) {
    const pl = this.stages.find((stage) => stage.id === id);
    return pl ? pl.PipelineLicenseStageName : 'Name Not found!';
  }

  checkPLRStage(id: string) {
    const plrstages = this.plrstageactivies.filter(
      (data) => +data.percentage > 0 && data.PLStageId === id
    );
    const data = plrstages.filter((data) => +data.percentage > 0);
    if (!!data.length) {
      this.deletePlrsEvent.emit(data);
    }
    return !!data.length ? true : false;
  }

  deleteErrMsg() {
    this.matSnackBar.open("You can't delete this data, is in use", 'exit', {
      duration: 2000,
    });
  }
}
